import React from 'react';
import GenericCrudPage from '../../components/GenericCrudPage/GenericCrudPage';
import {expiryLicenceActionColumns} from './datatableConfig';
import {expiryLicenceAction_URL} from "../../constants/urlConfig";

const ExpiryLicenceAction = () => <GenericCrudPage
    title="Expiry Licence Action"
    helptip="Administration panel for managing actions that need to be taken once Licence expires."
    linkFetch={expiryLicenceAction_URL}
    deleteAction={true}
    editAction={true}
    actionsEnabled={true}
    addModal={true}
    columns={expiryLicenceActionColumns()}
    expandRow={true}
    link={expiryLicenceAction_URL}
/>;

export default ExpiryLicenceAction;